import { defineStore } from 'pinia';

export interface ClientInfo {
  name: string;
  registeredMail: {
    enabled: boolean;
  };
  expressMail: {
    enabled: boolean;
  };
  ems: {
    enabled: boolean;
  };
  dhl: {
    enabled: boolean;
  };
  fedex: {
    enabled: boolean;
  };
  ups: {
    enabled: boolean;
  };
  parcel: {
    enabled: boolean;
  };
}
export interface CenterInfo {
  centerId: string;
  name: string;
  staff: boolean; // true: 유인, false: 무인
  registeredMail: {
    available: boolean;
  };
  expressMail: {
    available: boolean;
  };
  ems: {
    available: boolean;
  };
  dhl: {
    available: boolean;
  };
  parcel: {
    available: boolean;
  };
  quick:
    | boolean
    | {
        available: boolean;
      }
    | {
        enabled: boolean;
      };
}

interface AuthState {
  sessionToken: string;
  clientInfo: ClientInfo;
  centerInfo: CenterInfo;
  marketingAgreement: boolean | null;
}

const initialClientInfo = (): ClientInfo => ({
  name: '',
  registeredMail: {
    enabled: false,
  },
  expressMail: {
    enabled: false,
  },
  ems: {
    enabled: false,
  },
  dhl: {
    enabled: false,
  },
  fedex: {
    enabled: false,
  },
  ups: {
    enabled: false,
  },
  parcel: {
    enabled: false,
  },
});

const initialCenterInfo = (): CenterInfo => ({
  centerId: '',
  name: '',
  staff: true, // true: 유인, false: 무인
  registeredMail: {
    available: false,
  },
  expressMail: {
    available: false,
  },
  ems: {
    available: false,
  },
  dhl: {
    available: false,
  },
  parcel: {
    available: false,
  },
  quick: {
    available: false,
  },
});

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    sessionToken: '',
    clientInfo: initialClientInfo(),
    centerInfo: initialCenterInfo(),
    marketingAgreement: null,
  }),

  actions: {
    updateSessionToken(payload: string) {
      this.sessionToken = payload;
    },
    updateClientInfo(payload: ClientInfo) {
      this.clientInfo = payload;
    },
    updateCenterInfo(payload: CenterInfo) {
      this.centerInfo = payload;
    },
    updateMarketingAgreement(payload: boolean | null) {
      this.marketingAgreement = payload;
    },
    reset() {
      this.sessionToken = '';
      this.clientInfo = initialClientInfo();
      this.centerInfo = initialCenterInfo();
      this.marketingAgreement = null;
    },
  },
});
